/* eslint-disable eag/match-named-export */

export const MOBILE_DRAWER = {
  VISIBLE_CLASS_NAME: 'mobile-drawer-visible',
  ANIMATION_DURATION: 0.25,
};
